(() => {
  'use strict';

  const popup = document.getElementById('SihaNewsletterPopup');
  const storageKeys = {
    subscribed: 'siha_newsletter_subscribed_v1',
    dismissedAt: 'siha_newsletter_dismissed_at_v1'
  };
  const dismissWindow = 7 * 24 * 60 * 60 * 1000;

  const storageGet = (key) => {
    try { return window.localStorage.getItem(key); } catch (error) { return null; }
  };

  const storageSet = (key, value) => {
    try { window.localStorage.setItem(key, value); } catch (error) { /* storage can be unavailable */ }
  };

  const openPopup = () => {
    if (!popup || popup.open) return;
    if (typeof popup.showModal === 'function') {
      popup.showModal();
    } else {
      popup.setAttribute('open', '');
    }
    document.documentElement.classList.add('siha-popup-lock');
  };

  const closePopup = (rememberDismissal = true) => {
    if (!popup) return;
    if (rememberDismissal && storageGet(storageKeys.subscribed) !== '1') {
      storageSet(storageKeys.dismissedAt, String(Date.now()));
    }
    if (typeof popup.close === 'function' && popup.open) {
      popup.close();
    } else {
      popup.removeAttribute('open');
    }
    document.documentElement.classList.remove('siha-popup-lock');
  };

  if (popup) {
    const success = popup.querySelector('[data-siha-newsletter-success]');
    const error = popup.querySelector('[data-siha-newsletter-error]');
    const closeButton = popup.querySelector('[data-siha-popup-close]');

    if (success) {
      storageSet(storageKeys.subscribed, '1');
      window.setTimeout(openPopup, 220);
    } else if (error) {
      window.setTimeout(openPopup, 220);
    } else if (storageGet(storageKeys.subscribed) !== '1') {
      const dismissedAt = Number(storageGet(storageKeys.dismissedAt) || 0);
      const canShow = !dismissedAt || (Date.now() - dismissedAt) > dismissWindow;
      if (canShow) window.setTimeout(openPopup, 4000);
    }

    closeButton?.addEventListener('click', () => closePopup(true));

    popup.addEventListener('click', (event) => {
      if (event.target === popup) closePopup(true);
    });

    popup.addEventListener('cancel', (event) => {
      event.preventDefault();
      closePopup(true);
    });

    popup.addEventListener('close', () => {
      document.documentElement.classList.remove('siha-popup-lock');
    });
  }

  const main = document.querySelector('#MainContent[data-template^="index"]');
  if (!main) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  main.classList.add('siha-motion-ready');

  const hero = main.querySelector('.siha-hero');
  if (hero) {
    hero.classList.add('siha-motion-hero');
    if (reducedMotion) {
      hero.classList.add('is-visible');
    } else {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => hero.classList.add('is-visible'));
      });
    }
  }

  const sections = [...main.querySelectorAll('.shopify-section')].filter((section) => {
    if (section.querySelector('.siha-hero')) return false;
    if (section.querySelector('.siha-brand-strip')) return false;
    if (section.querySelector('.siha-scrolling-announcement')) return false;
    return true;
  });

  sections.forEach((section) => section.classList.add('siha-motion-reveal'));

  const cards = [...main.querySelectorAll('product-card.product-card')];
  cards.forEach((card) => card.classList.add('siha-motion-card'));

  if (reducedMotion || !('IntersectionObserver' in window)) {
    sections.forEach((section) => section.classList.add('is-visible'));
    return;
  }

  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, {
    rootMargin: '0px 0px -8% 0px',
    threshold: 0.08
  });

  sections.forEach((section) => revealObserver.observe(section));
})();
